// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Dg4n","rootCenter":"LoadMoreObserver_rootCenter__3bGT3","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__tPr2Y"};